import { Button, Nav, NavItem, NavLink, Navbar } from "reactstrap";
import { MdArrowBack, MdSave } from "react-icons/md";

function MenuGenerical({ title = "", onSave, children, hideSave = false }) {
  return (
    <div>
      <Navbar
        className="menu-bar-container menu-bar-variant"
        style={{ top: 60 }}
        color="light"
        expand="md"
      >
        <div className="menu-bar-main">
          <div>
            <Nav navbar className="main-nav-bar">
              <NavItem>
                <NavLink style={{ width: "17vw" }} href="#">
                  {title}
                </NavLink>
              </NavItem>
            </Nav>
          </div>
          <div className="menu-bar-profile">
            <Button
              color="primary"
              className="button-mid-height"
              onClick={() => window.history.back()}
            >
              <MdArrowBack />
            </Button>{" "}
            {children}{" "}
            {!hideSave ? (
              <Button
                color="primary"
                className="button-mid-height"
                onClick={() => onSave()}
              >
                <MdSave /> <span>Salvar</span>
              </Button>
            ) : null}
          </div>
        </div>
      </Navbar>
    </div>
  );
}

export default MenuGenerical;
